import React, { Component } from 'react';

import AgentDowntimeSeriesDataview from './AgentDowntimeSeriesDataview';

export default class AgentDowntimeSeries extends Component {
  componentDidMount() {
    this.onTimelineSelect();
  }

  componentDidUpdate(prevProps) {
    const { alarms } = this.props;

    if (prevProps.alarms !== alarms) {
      this.onTimelineSelect();
    }
  }

  onTimelineSelect = (time) => {
    const { alarms, onTimelineSelect } = this.props;
    const { timeslots } = alarms;
    if (onTimelineSelect) {
      onTimelineSelect(time || alarms.activeTestTime, timeslots);
    }
  };

  render() {
    const { approxWidth, alarms } = this.props;
    const { timeslots, minutesPerIncrement } = alarms;

    if (!timeslots) {
      return null;
    }

    return (
      <AgentDowntimeSeriesDataview
        width={approxWidth}
        data={timeslots}
        onHover={this.onTimelineSelect}
        minutesIncrement={minutesPerIncrement}
      />
    );
  }
}
